import {
  APIResponse,
  MessageResponse,
} from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  GET_LOGGED_USER_INFOS,
  TWO_FACTOR_AUTHENTICATIONS_URL,
} from '@utils/urls'

const verifyTwoFactorAuthentication = (
  code: string
): Promise<MessageResponse> =>
  SBAPI.Post<{ code: string }, APIResponse<MessageResponse>>(
    `${TWO_FACTOR_AUTHENTICATIONS_URL}/verify`,
    { code }
  ).then((response) => response.data)

const requestTwoFactorAuthentication = (dispatchId?: string) =>
  SBAPI.Post(`${TWO_FACTOR_AUTHENTICATIONS_URL}/request`, { dispatchId })

const updatePhoneTwoFactorAuthentication = (
  phone: string,
  dispatchId?: string
) => SBAPI.Put(`${GET_LOGGED_USER_INFOS}/phone`, { phone, dispatchId })

export {
  requestTwoFactorAuthentication,
  updatePhoneTwoFactorAuthentication,
  verifyTwoFactorAuthentication,
}
